import { Dispatch } from 'redux';

import { TwilioClient } from 'ha/types/Twilio';
import handleConnectionState from './handleConnectionState';
import { EventTypes } from '../constants';

export default (dispatch: Dispatch, client: TwilioClient) => {
  client.once(
    EventTypes.connectionStateChanged,
    handleConnectionState(dispatch, client),
  );

  return client;
};
